<template>
  <div class="flex w-full justify-center">
    <div class="flex flex-col gap-4 items-center">
      <h1 class="text-muted-green font-bold lg:text-8xl text-5xl font-Merriweather w-full">
        Hi! My name is 
        <span class="font-bold name-text">Clair Green</span>
      </h1>
      <h1 class="min-h-[4.5rem]">
        <span class="auto-type lg:text-5xl text-2xl font-normal font-Montserrat"></span>
      </h1>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import Typed from 'typed.js'

const typedOptions = {
  strings: [
    "I'm an aspiring Software Engineer",
    "I'm a Computer Science and Mathematics student at Notre Dame",
    "I love turning my ideas into reality with code",
    'Welcome to my portfolio!' 
  ],
  contentType: 'html',
  typeSpeed: 75,
  backSpeed: 75,
  startDelay: 500,
  backDelay: 1000,
  loop: true,
  showCursor: false
}

onMounted(() => {
  new Typed(".auto-type", typedOptions)
})
</script>

<style scoped>
.name-text {
  color: #6a998f;
  text-shadow: 4px 4px 8px #7a9686;
  font-family: 'Merriweather', sans-serif;
  font-weight: 700;
}
</style>


